<template>
  <div>
    <Table border :columns="columns1" :data="data1"></Table>
    <br />
    <Page
      :total="total"
      show-total
      @on-change="changePage"
      @on-page-size-change="changePagesize"
    />
  </div>
</template>
<script>
import expandRow from "./table.vue";
export default {
  components: { expandRow },
  props: {
    planId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      columns1: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row.log,
              },
            });
          },
        },
        // {
        //     title: '巡检计划ID',
        //     minWidth: 100,
        //     key: 'planId',
        //     align: 'center',
        //   },
        {
          title: "巡检名称",
          key: "patrolName",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.patrolName;
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "负责人",
          key: "maintainerName",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.maintainerName;
            return (
              <span
                style={{
                  color: row.row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "巡检周期",
          key: "patrolInterval",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.timeUnit == 1
                ? row.patrolInterval + "分钟"
                : row.timeUnit == 2
                ? row.patrolInterval + "小时"
                : row.timeUnit == 3
                ? row.patrolInterval + "天"
                : row.timeUnit == 4
                ? row.patrolInterval + "周"
                : row.timeUnit == 5
                ? row.patrolInterval + "月"
                : row.timeUnit == 6
                ? row.patrolInterval + "季度"
                : row.timeUnit == 7
                ? row.patrolInterval + "年"
                : "";
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        // {
        //   title: "巡检资产",
        //   key: "facilityListName",
        //   minWidth: 120,
        //   align: "center",
        //   // viewimage: true,
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.facilityListName;
        //     return (
        //       <span
        //         style={{
        //           color: row.state == 3 ? "red" : "",
        //           "font-size": "14px",
        //         }}
        //       >
        //         {text}
        //       </span>
        //     );
        //   },
        // },
        {
          title: "巡检开始时间",
          minWidth: 170,
          align: "center",
          key: "patrolBeginTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.patrolBeginTime;
            return (
              <span
                style={{
                  color: row.row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "备注信息",
          minWidth: 120,
          align: "center",
          key: "remark",
          render: (h, params) => {
            const row = params.row;
            const text = row.remark;
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "状态",
          minWidth: 120,
          key: "state",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state == 1
                ? "未巡检"
                : row.state == 2
                ? "已巡检正常"
                : row.state == 3
                ? "过时未巡检"
                : row.state == 4
                ? "延期"
                : "";
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },

        {
          title: "提交时间",
          minWidth: 170,
          align: "center",
          key: "updateTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.updateTime;
            return (
              <span
                style={{
                  color: row.type == 1 ? "red" : "",
                  "font-size": "14px",
                }}
              >
                {text}
              </span>
            );
          },
        },
      ],
      data1: [],
      total: this.total,
    };
  },
  created() {
  },
  mounted() {
    if (this.planId) {
      this.load(this.planId);
    }
  },
  methods: {
    load(planId, page = 1) {
      let q = {};
      // let a = {}
      // a.planId = planId
      q.planId = planId;
      // q.page = page
      q.pageSize = 10;
      q.pageNum = page;
      q.orderByColumn = "updateTime"
      q.isAsc="descending"
      $utils.api
        .load("/maintainer/maintainer/patrolLog/list", q)
        .then((res) => {
          if (res.code > 0) {
            let data = res.rows;
            let list = data || [];
            this.data1 = list;
            this.total = res.total;
          }
        })
        .catch(() => {
          $utils.toast.error("请求错误");
        });
    },
    changePage(p) {
      this.load(this.planId, p);
    },
    changePagesize(psize) {
    },
  },
};
</script>
